export class Currency {
  constructor(readonly symbol: string) {}
}

export class Money {
  constructor(
    readonly amount: number,
    readonly currency: Currency,
  ) {}
}

export const UsdCurrency = new Currency("USD");
